export const merchantState = {
  currentMerchantItems: [],
  currentMerchant: null,
  currentMerchantObject: null,
  companyTypeGroups: [],
  merchantMessages: [],
  merchantInformation: null,
  merchantStatusList: [],
  merchantIsManufacturer: false
};